// auto-open-cart.js — Ride/Dawn
// Intercepte l'ajout au panier, ajoute via AJAX, ouvre le drawer natif et affiche un toast centré.

(function () {
  const FORMS = 'form[action="/cart/add"], form[data-type="add-to-cart-form"]';
  const HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);

  function bind() {
    document.querySelectorAll(FORMS).forEach((form) => {
      if (form.dataset.ndaBound === '1') return;
      form.dataset.ndaBound = '1';

      form.addEventListener(
        'submit',
        async (e) => {
          // Empêche la redirection pour gérer nous-mêmes l’ajout
          e.preventDefault();

          const idEl = form.querySelector('[name="id"]');
          const qtyEl = form.querySelector('[name="quantity"]');
          const btn = form.querySelector('[type="submit"]');

          const id = idEl && idEl.value;
          const qty = qtyEl && qtyEl.value ? parseInt(qtyEl.value, 10) : 1;
          if (!id) {
            showToast('<span style="color:#ff4d4f;font-weight:700;margin-right:8px;">!</span> Variante invalide');
            return;
          }

          lock(btn, true);

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: HEADERS,
              body: JSON.stringify({ id, quantity: Math.max(1, qty) }),
              credentials: 'same-origin',
            });

            if (!res.ok) {
              // message d’erreur lisible (422/400…)
              let msg = 'Impossible d’ajouter cet article.';
              try {
                const data = await res.json();
                msg = data?.description || data?.message || msg;
              } catch (_) {}
              showToast('<span style="color:#ff4d4f;font-weight:700;margin-right:8px;">✕</span>' + escapeHtml(msg));
              return;
            }

            // OK : met à jour compteur + ouvre drawer + toast
            await refreshCount();
            openNativeDrawer();
            showToast('<span style="color:#00d9ff;text-shadow:0 0 8px #00d9ff;font-weight:700;margin-right:8px;">✓</span> Ajouté au panier');
          } catch (err) {
            console.error('[NDA] add.js error', err);
            showToast('<span style="color:#ff4d4f;font-weight:700;margin-right:8px;">✕</span> Problème réseau. Réessaie.');
          } finally {
            lock(btn, false);
          }
        },
        { capture: true } // passe avant d’autres scripts qui interceptent aussi
      );
    });
  }

  function lock(btn, state) {
    if (!btn) return;
    btn.disabled = !!state;
    btn.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  async function refreshCount() {
    try {
      const r = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!r.ok) return;
      const cart = await r.json();

      // Met à jour toutes les bulles connues (Ride/Dawn)
      document
        .querySelectorAll('[data-cart-count], .cart-count-bubble .text, #cart-icon-bubble .text')
        .forEach((el) => (el.textContent = cart.item_count));

      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) bubble.classList.toggle('hidden', cart.item_count === 0);
    } catch (_) {}
  }

  function openNativeDrawer() {
    // 1) Web component récent
    const c = document.querySelector('cart-drawer');
    if (c) {
      if (typeof c.open === 'function') {
        c.open();
        return;
      }
      c.setAttribute('open', 'true');
      c.classList.add('is-open');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }
    // 2) Ancien ID (#CartDrawer)
    const d = document.getElementById('CartDrawer') || document.querySelector('#CartDrawer');
    if (d) {
      try {
        d.open = true;
      } catch (_) {}
      d.setAttribute('open', 'open');
      return;
    }
    // 3) Fallback via bouton qui contrôle le drawer
    const btn = document.querySelector(
      '[aria-controls="CartDrawer"], [data-action="open-drawer"], a[href="#CartDrawer"], button[href="#CartDrawer"]'
    );
    if (btn) btn.click();
  }

  // Toast centré (accepte HTML)
  function showToast(html) {
    let t = document.getElementById('nda-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'nda-toast';
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('show'), 2000);
  }

  // Sécurité si on injecte du texte dynamique dans le toast (erreurs serveur)
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  }
})();
